<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>COMMITTEES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Committees</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="blogs">
    <div class="container">
        <div class="row ">
            <div class="col-md-12 col-lg-12 ">
                <div class="sidebar">
                    <div class="widget">
                        <div class="widget-title">
                            <h3>UNIVERSITY COMMITTEES</h3>
                        </div>
                        <ul class="course-tags">
                            <li><a href="#!">Anti-Ragging Committee Contact Person : Mobile: EmailID:</a></li>
                            <li><a href="#!">Hostel Discipline Committee</a></li>
                            <li><a href="#!">Proctorial Board</a></li>
                            <li><a href="#!">SC/ST Welfare Committee</a></li>
                            <li><a href="#!">Social & Cultural Committee</a></li>
                            <li><a href="#!">Sports & Athletics Committee</a></li>
                            <li><a href="#!">Student Grievance Committee</a></li>
                            <li><a href="">Technology Incubation & Innovation Cell</a></li>
                            <li><a href="">University Discipline Committee</a></li>
                            <li><a href="">Internal Complaints Committee (ICC)</a></li>
                            <li><a href="">Students Consultative Committee</a></li>
                            <li><a href="">Women Welfare Cell</a></li>
                            <li><a href="">Finance Committee</a></li>
                            <li><a href="">Employee Grievance Committee</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
